module.exports = __webpack_public_path__ + "static/5-f0c7ccceb772ff59cab06969173db986.jpg";